import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { useForm } from "react-hook-form";
import { RiCloseFill, RiCloseLargeFill } from "react-icons/ri";
import { Col, Container, Row } from "reactstrap";
import API_URL from "../../Api";
import axios from "axios";
import moment from "moment/moment";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";

const schema = yup.object().shape({
  email: yup.string().email("Email is not valid").required("Email is required"),
  city: yup.string().required("City is required"),
  format: yup.string().required("Format is required"),
  date: yup.string().required("Date is required"),
  time: yup.string().required("Time is required"),
  speakerName: yup.string().required("Speaker Name is required"),
  job: yup.string().required("Job title is required"),
  photo: yup.mixed().required("Photo is required").test("fileSize", "Photo must be less than 2MB", (value) => {
    return value && value[0]?.size <= 2 * 1024 * 1024;
  }),
  confirm: yup.bool().oneOf([true], "You must confirm joining info session by click the confirmation checkbox"),
});

export default function FormOrder() {

  const { register, handleSubmit, getValues, setValue, reset, trigger, formState: { errors },} = useForm({
    resolver: yupResolver(schema),  
    defaultValues: {
      email: "",
      city: "",
      format: "",
      time: "",
      date: "",
      speakerName: "",
      job: "",
      photo: null,
      ads: "",
      confirm: false,
    }    
  });

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
        const errorElement = document.querySelector(
          `[name="${firstErrorField}"]`
        );
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }
  }, [errors]);

useEffect(() => {
  if (errors?.email) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}, [errors.email]);  

  const [_selectedDate, _setSelectedDate] = useState(null);
  const [_cities, _setCities] = useState([]);
  const [_preview, _setPreview] = useState(null);
  const [_invoices, _setInvoices] = useState([]);
  const [_dataInvoices, _setDataInvoices] = useState([]);
  const [_allEvents, _setAllEvents] = useState([]);

  const cityTimezoneMap = {
    Denpasar: "WITA",
    Yogyakarta: "WIB",
    Medan: "WIB",
    Makassar: "WITA",
    Jakarta: "WIB",
    Tangerang: "WIB",
    Surabaya: "WIB",
  };

  const handlePhoto = async (e) => {
    const file = e.target.files[0];
    if (file) {
      _setPreview(URL.createObjectURL(file));
    }
    await trigger("photo");    
  };

  const getInfoSession = () => {
  API_URL.baseUrl.get('event/jenis-event-date/2')
    .then(res => res.data)
    .then(data => _setAllEvents(data.data));
  }; 

  const fetchPrice = async (id_area) => {
    try {
      const res = await API_URL.development.get(`/event/price-event-area/${id_area}`);
      return res?.data?.data?.price ?? 0;
    } catch (error) {
      console.error("Gagal fetch harga:", error);
      return 0;
    }
  };

  const blockedDates = _allEvents.map(event => {
    const rawDate = event?.event_lokasi?.[0]?.time_event || event.start_date;
    return moment(rawDate).startOf("day").toDate();
  });

  const handleSave = async () => {
    const isValid = await trigger([
      "email",
      "city",
      "format",
      "date",
      "time",
      "speakerName",
      "job",
      "photo",      
    ]); 
    if (!isValid) return;

    const values = getValues();
    const selectedDateOnly = moment(values.date).startOf("day").format("YYYY-MM-DD");
    const eventDates = _allEvents.map(event =>
      moment(event?.event_lokasi?.[0]?.time_event || event.start_date).startOf("day").format("YYYY-MM-DD")
    );

    if (eventDates.includes(selectedDateOnly)) {
      alert("There is already an event on this date. Please choose another date.");
      return;
    }

    const selectedCity = _cities.find(c => c.area === values.city);
    
    const price = await fetchPrice(selectedCity.id_area);    

    const timezone = cityTimezoneMap[values.city] || "WIB"; 
    const [hours, minutes] = values.time.split(":");
    const fullDate = new Date(_selectedDate);
    fullDate.setHours(hours, minutes);

    const formattedDate = fullDate.toLocaleDateString("en-GB", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    const formattedTime = values.time;
    const rawDateTime = moment(fullDate).format("YYYY-MM-DD HH:mm:ss");
    const id = `${selectedCity.id_area}_${rawDateTime}_${Date.now()}`;

    const newInvoice = {
      id,
      city: values.city,
      format: values.format,
      dateTime: `${formattedDate}, ${formattedTime} ${timezone}`,  
      datetime_event: rawDateTime,
      price: values.format === "Online" ? 0 : price,
      ads: 0,
    }
    _setInvoices((prev) => [...prev, newInvoice]);  
      
    const newDataInvoice = {
      id,
      city: selectedCity.id_area, 
      format: values.format,
      datetime_event: rawDateTime,
      price: values.format === "Online" ? 0 : price,
      ads: 0,
    };
    _setDataInvoices((prev) => [...prev, newDataInvoice]);    

    reset({
      city: "",
      format: "",
      time: "",
    });    
    _setSelectedDate(null);   
    window.scrollTo({ top: 0, behavior: "smooth" });    
  };

  const handleRemove = () => {
    _setPreview(null);
    // reset file input supaya bisa pilih file yang sama lagi
    const input = document.getElementById("fileUpload");
    if (input) input.value = "";
  };  

  const fetchCities = () => {
      API_URL.development.get('/api/v1/application/master/area')
          .then(res => res.data)
          .then(data => _setCities(data.data));
  };

  useEffect(() => {
    fetchCities();
    getInfoSession();
  }, []);

  const totalPriceCart = _invoices.reduce((acc, item) => {
    const base = Number(item.price);
    const adsCost = item.ads === "1" ? 500000 : 0;
    return acc + base + adsCost;    
  }, 0);  

  const onSubmit = async () => {
    if (_invoices.length === 0) {
    Swal.fire({
      icon: "error",
      title: "The invoice is empty",
      text: "Please fill the invoice first.",
    });      
      // alert("Please fill the invoice first");
      return;
    }

    const isValid = await trigger("confirm");
    if (!isValid) return;    

    try {
      const values = getValues();         
      const formData = new FormData();
      _dataInvoices.forEach((item, index) => {   
        const priceBase = item.format === "Online" ? 0 : item.price;
        let priceWithAds = priceBase;
        let statusAds = 0;
        if (item.ads === "1") {
          priceWithAds += 500000;
          statusAds = 1;
        }      

        formData.append(`data[${index}][email]`, values.email);       
        formData.append(`data[${index}][id_area]`, item.city);       
        formData.append(`data[${index}][format_event]`, item.format);       
        formData.append(`data[${index}][price]`, priceWithAds);             
        formData.append(`data[${index}][datetime_event]`, item.datetime_event);       
        formData.append(`data[${index}][speaker_name]`, values.speakerName);       
        formData.append(`data[${index}][speaker_job_title]`, values.job);       
        formData.append(`data[${index}][status_ads]`, statusAds);       
        formData.append(`data[${index}][speaker_foto]`, values.photo[0]);            
      })

      const res = await axios.post("https://development.niecindonesia.com/event/booking-event", formData, {
        headers: {
          "Authorization": "Bearer eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ"
        },
      });

    Swal.fire({
      icon: "success",
      title: "Order Successful!",
      showConfirmButton: true,
      confirmButtonText: "OK"
    }).then(() => {
      reset();
      _setInvoices([]);
      _setPreview(null);
      window.scrollTo({ top: 0, behavior: "smooth" });    
    });      

    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Order sending failed. Please try again.",
      });      
    }
  };

  return(
          <section id="form-order">
            <Container className="mt-5 mb-5">
              <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col md='6'>
                    <h1 className="form-header">Infosession Form Order</h1>
                      <Col>
                        <label className="form-label" htmlFor="email">E-mail</label>
                        <input className="form-input" id="email" type="email" autoComplete="none" {...register("email")} />
                        {errors.email && (
                          <p className="error-text">{errors.email.message}</p>
                        )}                        
                      </Col>
                      <Col className="mt-3">
                        <span className="form-label">Choose City</span>
                        <Row className="mt-2">
                          {_cities.map((data, index) => (
                            <Col md='6' key={index}>
                              <input className="me-2" id={`city-${index}`} type="radio" value={data.area} {...register("city")} />                  
                              <label className="form-label" htmlFor={`city-${index}`}>{data.area}</label>                           
                            </Col>                             
                          ))}                       
                        </Row>   
                        {errors.city && (
                          <p className="error-text mt-1">{errors.city.message}</p>
                        )}                                                
                      </Col>    
                      <Col className="mt-2">
                        <label className="form-label" htmlFor="format">Format Event</label>
                        <select className="form-select" id="format" {...register("format")}>
                          <option value="">Pilih format event</option>
                          <option value="Online">Online</option>
                          <option value="Offline">Offline</option>
                        </select>
                        {errors.format && (
                          <p className="error-text mt-1">{errors.format.message}</p>
                        )}                          
                      </Col>                                  
                      <Col className="mt-3">
                        <Row>
                          <Col>
                            <Col>
                              <label className="" htmlFor="date">Date</label>
                              <input className="form-input" type="text" id="date" value={_selectedDate ? _selectedDate.toLocaleDateString("en-US", {weekday: "long", month: "long", day: "numeric",}) : ""} readOnly {...register("date")}/>                      
                              {errors.date && (
                                <p className="error-text mt-1">{errors.date.message}</p>
                              )}                            
                            </Col>
                            <Col className="mt-3">
                              <DatePicker
                                selected={_selectedDate}
                                onChange={(date) => {
                                  _setSelectedDate(date)
                                  setValue("date", date, { shouldValidate: true })
                                }}
                                inline
                                minDate={new Date(new Date().setDate(new Date().getDate() + 7))}
                                filterDate={(date) => date.getDay() !== 0}
                                openToDate={new Date(new Date().setDate(new Date().getDate() + 7))}                             
                                excludeDates={blockedDates}
                                dayClassName={(date) =>
                                  date.getDay() === 0 ? "sunday-red" : undefined
                                }                                
                              />                        
                            </Col>
                          </Col>
                          <Col>
                            <Col>
                              <span className="form-label">Time</span>
                            </Col>
                            <Col>
                              <Col>
                                <input className="me-2" id="time1" type="radio" value="14:00" {...register("time")} />                  
                                <label className="form-label" htmlFor="time1">14:00 - 15:00 PM</label>                            
                              </Col>
                              <Col>
                                <input className="me-2" id="time2" type="radio" value="16:00" {...register("time")} />                  
                                <label className="form-label" htmlFor="time2">16:00 - 17:00 PM</label>                           
                              </Col>                                                                            
                            </Col>
                            {errors.time && (
                              <p className="error-text mt-1">{errors.time.message}</p>
                            )}                              
                          </Col>    
                        </Row>    
                      </Col>  
                      <Row className="mt-3">
                        <Col>
                          <label className="form-label" htmlFor="speaker">Speaker Name</label>                       
                          <input className="form-input" type="text" id="speaker" {...register("speakerName")}/>                        
                          {errors.speakerName && (
                            <p className="error-text mt-1">{errors.speakerName.message}</p>
                          )}                            
                        </Col>                                            
                      </Row>                         
                      <Row className="mt-3">
                        <Col>
                          <label className="form-label" htmlFor="job">Job Title</label>                       
                          <input className="form-input" type="text" id="job" {...register("job")}/>                         
                          {errors.job && (
                            <p className="error-text mt-1">{errors.job.message}</p>
                          )}                         
                        </Col>                                              
                      </Row>  
                      <Row className="mt-3">
                        <Col md='8'>
                        <span>Upload speaker photo profile</span>
                        <p className="font-s"><b>*Maximum photo size is 2MB.</b></p>                      
                        </Col>
                        <Col md='4 d-flex justify-content-end'>
                        <label className="custom-btn" htmlFor="fileUpload">Browse</label>                
                        <input id='fileUpload' type="file" accept="image/*" {...register("photo", { onChange: handlePhoto})} style={{ display: "none" }}/>                                                    
                        </Col>
                        {errors.photo && (  
                          <p className="error-text mt-1">{errors.photo.message}</p>
                        )}                         
                      </Row>
                      {_preview && (
                        <>
                          <Row className="mt-3">
                            <Col>
                              <div className="preview">
                                <img
                                  src={_preview}
                                  alt="Preview"
                                  className="img-fluid rounded"
                                />
                                <button className="rounded-circle remove" size="sm" onClick={handleRemove}>
                                  <RiCloseLargeFill style={{ strokeWidth: 2 }}/>
                                </button>  
                              </div>                                                                                       
                            </Col>
                          </Row>                      
                        </>
                      )}
                      <Row className="mt-4">
                        <Col className="d-grid">
                          <button type="button" className="custom-btn" onClick={handleSave}>SAVE</button>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <span className="font-s">*If you are ordering for more than one city, please fill out the form from the top.</span>                      
                        </Col>
                      </Row>                    
                  </Col>
                  
                  <Col md='6'>
                    <h1 className="form-header">Details</h1>
                    <Row className="detail-cap">
                      {_invoices.length > 0 && (
                      <>
                        {Object.entries(
                          _invoices.reduce((acc, item) => {
                            if (!acc[item.format]) acc[item.format] = [];
                            acc[item.format].push(item);
                            return acc;
                          }, {})
                        ).map(([format, items], index) => (
                          <div key={index} className={index > 0 ? "mt-4" : ""}>
                            <Row>
                              <Col>
                                <p><b>{`${format} Event`}</b></p>
                              </Col>
                            </Row>                        
                            <Row>
                              <div className="line"></div>                   
                            </Row> 
                            {items.map((data, index) => (
                              <React.Fragment key={index}>
                                <Row>
                                  <Col xs='12' md='12' xl='9' className="list-invoice ps-4 pe-0">
                                    <p><b className="d-inline d-md-block d-lg-inline">{data.city},</b> <span className="d-inline d-md-block d-lg-inline">{data.dateTime}</span></p>
                                  </Col>
                                  <Col xs='12' md='12' xl='3' className="d-flex align-items-center p-0 flex-row justify-content-between">
                                    <p className="mb-0 price">{`: IDR ${Number(data.price).toLocaleString("id-ID")}`}</p>
                                    <span className="delete-cart">
                                      <RiCloseFill
                                        style={{ strokeWidth: 2, cursor: "pointer" }}
                                        onClick={() =>
                                          _setInvoices((prev) =>
                                            prev.filter((inv) => !(inv.city === data.city && inv.dateTime === data.dateTime))
                                          )
                                        }
                                      />
                                    </span>
                                  </Col>                          
                                </Row>
                                <Row>
                                  <Col md='8' className="ms-3">
                                  <input 
                                    type="checkbox" 
                                    value="1"
                                    className="me-2"
                                    id={`ads-${index}`}
                                    checked={data.ads === "1"}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      const newAdsVal = checked ? "1" : "0";
                                      _setInvoices(prev =>
                                        prev.map(inv =>
                                          inv.id === data.id ? { ...inv, ads: newAdsVal } : inv
                                        )
                                      );

                                      _setDataInvoices(prev =>
                                        prev.map(inv =>
                                          inv.id === data.id ? { ...inv, ads: newAdsVal } : inv
                                        )
                                      );                                      
                                    }}                                    
                                  />    
                                  <label className="form-label" htmlFor={`ads-${index}`}>
                                    Need Ads (<span style={{"color" : "red"}}><i>Click to add Ads booster</i></span>)
                                  </label>  
                                  </Col>
                                  <Col md='2' className="p-0 price-ads">
                                    <p>
                                      {`: IDR ${
                                        data.ads === "1"
                                          ? Number(500000).toLocaleString("id-ID")
                                          : 0
                                      }`}  
                                    </p>                                    
                                  </Col>                                                                                                    
                                </Row>     
                                    <Row>
                                      <Col md='7'>
                                        <p className="ads-label"><b>{data.ads === "1"? "Ads Social Media Post & Meta Ads" : "No Ads"}</b></p>
                                      </Col>                                                                            
                                    </Row>
                                <Row>
                                  <div className="line"></div>                   
                                </Row>                                
                              </React.Fragment>
                            ))}      
                          </div>
                        ))}                 
                      </>                        
                      )}
                    </Row>
                    <Row className="mb-5">
                      <Col>
                        <h3>Total Price :</h3>
                        <h1>{`Rp. ${totalPriceCart.toLocaleString("id-ID")}`}</h1>
                        <hr />
                        <span>*Price includes room rental, projector, and participant snacks.</span>                    
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                      <div className="mb-4">
                        <input
                          {...register("confirm")} 
                          type="checkbox" 
                          className="me-2"
                        />                    
                        <span>We Confirm to Join Infosession</span>
                        {errors.confirm && (
                          <p className="error-text text-sm mt-1">
                            {errors.confirm.message}
                          </p>
                        )}                        
                      </div>                    
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <ul className="list-none">
                          <li>Participant fee must be transferred to:</li>
                          <li>OCBC NISP, BRANCH TEUKU UMAR DENPASAR BALI</li>
                          <li className="mt-3">Account Name: CV Naresy Indonesia</li>
                          <li>Account Number :160800014310</li>
                          <li>Swift Code: NISPIDJA</li>
                          <li>Branch Code: 07160</li>
                          <li>Bank Code: 028</li>
                        </ul>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <button type="button" onClick={onSubmit} className="custom-btn">Order</button>
                      </Col>
                    </Row>
                  </Col>                
                </Row>
              </form>                                  
            </Container>

            <div className="event-ca pt-5 pb-5">
              <Container >
              <Row className="mb-5">
                <Col>
                  <h1>NIEC CALENDAR EVENT</h1>
                </Col>
              </Row>                  
                <Row>
                  <Col md="6">
                    {_allEvents.slice(0, 6).map((event, index) => (
                      <div key={index} className="d-flex mb-5">
                        <div className="me-3 text-center">
                          <p className="order-date">
                            {moment(event?.event_lokasi?.[0]?.time_event || event.start_date).format("DD")}
                          </p>
                          <p className="order-month">
                            {moment(event?.event_lokasi?.[0]?.time_event || event.start_date)
                              .locale("en")
                              .format("MMM")
                              .toUpperCase()}
                          </p>
                        </div>
                        <div className="d-flex flex-column justify-content-center">
                          <p>{event.name}</p>
                        </div>
                      </div>
                    ))}
                  </Col>

                  <Col md="6">
                    {_allEvents.slice(6).map((event, index) => (
                      <div key={index + 6} className="d-flex mb-5">
                        <div className="me-3 text-center">
                          <p className="order-date">
                            {moment(event?.event_lokasi?.[0]?.time_event || event.start_date).format("DD")}
                          </p>
                          <p className="order-month">
                            {moment(event?.event_lokasi?.[0]?.time_event || event.start_date)
                              .locale("en")
                              .format("MMM")
                              .toUpperCase()}
                          </p>
                        </div>
                        <div className="d-flex flex-column justify-content-center">
                          <p>{event.name}</p>
                        </div>
                      </div>
                    ))}
                  </Col>
                </Row>
              </Container>               
            </div>            
          </section>    
  )
};